import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { RoadTypesFailure, RoadTypesRequest, RoadTypesSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'roadTypes';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(RoadTypesFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(RoadTypesRequest, state => ({ ...state, error: null, loading: true })),
    on(RoadTypesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
